import { from, Subject } from 'rxjs';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss'],
})
export class UnitsComponent implements OnInit, AfterViewInit {
  changingValue: Subject<boolean> = new Subject();
  unit:string = '';
  prcsn:string = '';
  ind: number = 0;
  isEdit: boolean = false;
  prcsnCount: string = ''
  jarvisData: any = []; 
  units: any = [];
  unitsCopy: any = [];
  agencyData: any = [];
  defaulUnit: Array<any> = [];
  changeUnitLog: Array<any> = [];
  @ViewChild('mymodal') addModalRef!: TemplateRef<any>;
  mdlRef: any;
  showOnlyAddModal: boolean = false;
  modalshow: boolean = false;
  
  constructor(private modalService: NgbModal,private apiService: APIService, private router: Router, private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.defaulUnit = [{
        uID: 1,
        uNm: 'no.s'
      },{
        uID: 2,
        uNm: 'pcs'
      },{
        uID: 3,
        uNm: 'mm'
      },{
        uID: 4,
        uNm: 'cm'
      },{
        uID: 5,
        uNm: 'm'
      },{
        uID: 6,
        uNm: 'km'
      },{
        uID: 7,
        uNm: 'in'
      },{
        uID: 8,
        uNm: 'ft'
      },{
        uID: 9,
        uNm: 'mg'
      },{
        uID: 10,
        uNm: 'g'
      },{
        uID: 11,
        uNm: 'kg'
      }
    ];

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.getUnits()
    this.getPrscn()
  }

  ngAfterViewInit(): void {
    if (this.mdlRef) {
      this.open(this.addModalRef, 0);
    }

    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open(this.addModalRef, 0);
        }, 100);
      }
    });
  }

  closeResult: any;
  modalReference: any;

  // getUnits() - get all units from database
   getUnits(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                  let editDataArry = JSON.parse(reponseData.Table2[0].Units);
                  for(let j = 0; j < editDataArry.length; j++){
                    let defaultUnt: Array<any> = this.defaulUnit.filter((x: any) => x.uNm == editDataArry[j].UNm);
                      this.units.push({
                        'UID': editDataArry[j].UID,
                        'Prcsn': editDataArry[j].Prcsn,
                        'UNm': editDataArry[j].UNm,
                        'PrcCount': '',
                        'isDefault': defaultUnt.length > 0 ? false: true
                      });
                  }
                  
              }
              this.getPrscn()
          }
      }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    // else {
    //     alert(res.message);
    // }
  }
  
  // open() - open edit unit and add new unit modal 
  open(content: any, id:number) { 
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'unitModal', backdrop: 'static', keyboard: false});
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      if(id == 0){
        this.isEdit = false;
        this.unit = '';
        this.prcsn = '';
      }
      else if(id != 0){
        var UnitData = this.units.filter(function (element: any, index: any) {
          return (element.UID == id);
      });
        this.isEdit = true;
        this.ind = id;
        this.prcsn = UnitData[0].Prcsn.toString();
        const unitOld:string = UnitData[0].UNm;
        this.unit = unitOld;
      }
    
  }

  closeModelUnit() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  public closeModal($event: any) {
    this.isEdit = false;
    this.modalReference.close();
    if(this.showOnlyAddModal) {
      this.closeModelUnit();
    }
    if ($event) {
        this.changingValue.next($event);
    }
  }
  
  // getPrscn() - display N for precision 
  getPrscn(){
    this.units.sort((a:any,b:any) => a.UNm.localeCompare(b.UNm));
    for(let j = 0; j < this.units.length; j++){
      let prCount = '';
    if(this.units[j].Prcsn == 0){
      this.units[j].PrcCount = '';
    }
    else{
      for(let i = 0; i < this.units[j].Prcsn; i++){
        prCount = prCount.concat('N');
      }
      this.units[j].PrcCount = prCount
    }
   
    }
  }

  // saveNewUnit() - add new unit
  saveNewUnit(unit: string,p: number){
    var temp: any = /^(0|[1-6]\d*)$/;
    if(!(temp.test(p))){
      this.prcsn = ''
      this.apiService.successAlert("Please enter precision")
      return
    }
    var temp: any = []
    if(unit.trim() == ''){
      this.apiService.successAlert("Please enter unit name.")
      this.unit = '';
      return;
    }
    let flag = false;
    if(p == 0){
      temp = {
        UID:this.units.length + 1,
        UNm:unit.replace(/ {2,}/g, ' ').trim(),
        Prcsn:p,
        PrcCount:'N'
      }
    }
    else{    
      let prCount: string = ''
      for(let i = 0; i < p; i++){
        prCount = prCount.concat('N');
      }
      temp = {
        UID:this.units.length + 1,
        UNm:unit.replace(/ {2,}/g, ' ').trim(),
        Prcsn:p,
        PrcCount:prCount
      }
    }
    for (let i = 0; i < this.units.length; i++) {
      if((unit.replace(/ {2,}/g, ' ').trim()).toUpperCase() == this.units[i].UNm.toUpperCase()){
        flag = true
        break
      }
    }
    
    if(!flag){
      this.units.push(temp);
      this.unit = '';
      this.prcsn = '';
      this.save()
      this.modalReference.close();
    }
    else
    {
      this.apiService.successAlert("This unit already exists.")
      this.unit = '';
      this.prcsn = '';
      return;
    }
  }  
 
  // editUnitSave() - edit unit
  editUnitSave(name: string, p: number){
    debugger;
    this.changeUnitLog = [];
    var temp: any = /^(0|[1-6]\d*)$/;
    var editInd = this.ind;
    var UnitData = this.units.filter(function (element: any, index: any) {
      return (element.UID == editInd);
    });

    this.changeUnitLog = [{
      UID: UnitData[0].UID,
      UNm: UnitData[0].UNm,
      OP: UnitData[0].Prcsn.toString(),
      NP: p,
      UserID: this.jarvisData[0].UserID,
      DT: new Date().customFormat('#DD#-#MMM#-#YY# #hh#:#mm# #AMPM#')
    }];


    var prId = UnitData[0].PrcCount;
    if(name.trim() == ''){
      this.unit = UnitData[0].UNm;
      //this.prcsn = UnitData[0].Prcsn.toString();
      this.apiService.successAlert("Please enter unit name.")
      return;
    }
    if(!(temp.test(p))){
      //this.unit = UnitData[0].UNm;
      this.prcsn = UnitData[0].Prcsn.toString();
      this.apiService.successAlert("Please enter valid precision")
      return
    }
    
    let flag = false;
    if(UnitData[0].UNm == name.trim()){
      flag = false
    }
    else{
      for (let i = 0; i < this.units.length; i++) {
        if(name.trim() == this.units[i].UNm){
          flag = true
          break
        }
      }
    }
    
    if(!flag){
      if(p == 0){
        for(let i = 0; i < this.units.length; i++){
          if(this.units[i].UID == UnitData[0].UID){
            this.units[i].UNm = name.trim();
            this.units[i].PrcCount = 'N';
            this.units[i].Prcsn = p;
            break
          }
        }
        //this.units[this.ind].PrcCount = 'N';
      }
      else{    
        let prCount: string = ''
        for(let i = 0; i < p; i++){
          prCount = prCount.concat('N');
        }
        for(let i = 0; i < this.units.length; i++){
          if(this.units[i].UID == UnitData[0].UID){
            this.units[i].PrcCount = prCount;
            this.units[i].Prcsn = p;
            this.units[i].UNm = name.trim();
            break
          }
        }
        //this.save()
      }
    
      this.save();
      this.modalReference.close();
    }
    else
    {
      this.unit = UnitData[0].UNm;
      this.prcsn = UnitData[0].Prcsn;
      this.apiService.successAlert("This unit already exists.")
      return;
    }
  }

  // editUnitSave() - only enter 1-6 number 
  omit_special_char(event: any)
  { 
    if(event < 6){
      var k;  
      k = event.charCode; 
      return((k >= 48 && k <= 54)); 
    } 
    else{
      return
    } 
   
  }

  // save final data
  save(){
    this.unitsCopy = [];
    for(let j = 0; j < this.units.length; j++){
      let temp = {
        UID:this.units[j].UID,
        UNm:this.units[j].UNm,
        Prcsn:parseInt(this.units[j].Prcsn),
      }
      this.unitsCopy.push(temp);
    }
    var tempData = [{
      'ChangeType': 'UNIT',
      'GSTLdgrs':'',
      'Units': JSON.stringify(this.unitsCopy),
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod':1,
      'PrdRejnReasons': '',
      'HSNSAC':'',
      'CurrUnitChng': (this.changeUnitLog.length > 0 ? JSON.stringify(this.changeUnitLog) : '[]')
  }]
  let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
  }];
  this.apiService.sendChange(myParams, this.successEdit.bind(this), this.failureResponse.bind(this));
  }

   //successVchrEntry - success voucher entry handler
   successEdit(res: any) {
    if (res.error) {
    }
    else {
      this.changeUnitLog = [];
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
          if (ErpData.Table1) {
            let coockieData = [];
            coockieData.push(ErpData.Table1[0]);
            let ErpAgn = JSON.stringify(coockieData);
            localStorage.setItem("ERP_Agn", ErpAgn)
          }
          if (ErpData.Table2) {
            let cookieData2 = [];
            cookieData2.push(ErpData.Table2[0]);
            let ErpCfgData = JSON.stringify(cookieData2);
            localStorage.setItem("ERP_Cfg", ErpCfgData)
          }
    }
        this.units = [];
        this.getUnits();      
        this.modalReference.close();
        this.closeModelUnit()
    }
}

//failureResp - failure handler
failureResponse(res: any) {
  if (res.error) {
  }
  // else {
  //     alert(res.message);
  // }
}

//back() - back to settings
back(){
  /*this.router.navigate(['Settings']);*/
  window.history.back();
}

backBtn() {
  window.history.back();
}

  //fn_deleteUnits() - Unit delete
  fn_deleteUnits(uID: number, ind: number){
    this.apiService.swalConfirm("Are you sure you wish to delete this unit?", () => {
      let objUnits: Array<any> = this.units.filter((x: any) => x.UID == uID);
        if(objUnits.length > 0){
          this.apiService.getIDB('erp_inv', (invItems: any) => {
            if (invItems && invItems.length > 0) {
              let erpInv = invItems;
              let isUsedUnit = erpInv.filter((x: any) => x.SKU == objUnits[0].UNm);
              if(isUsedUnit.length > 0){
                this.apiService.successAlert("This unit already used in your product.");
                return;
              }
              else{
                this.units.splice(ind, 1);
                this.save();
              }
            }
          });
        }
    });    
  }

}
